import { Component } from "@angular/core";

@Component({
  templateUrl: "./index.html",
  standalone: false,
})
export class IndexComponent {

}
